
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import api from '../../../api'
import { TextBoxField, FormGroup } from '@appbase/components/forms'

/**
 * 템플릿 추가/편집 모달
 * 템플릿의 상세 설정을 수정할 수 있다.
 */
@Component({
    components: { TextBoxField, FormGroup },
})
export default class TemplateModalContent extends Vue {
    @Prop({ type: Object, required: true }) value!: webpartv3.WebpartTemplate
    /** 메뉴에서 구성한 웹파트 페이지 목록 */
    @Prop({ type: Array, required: true }) pages!: webpartv3.WebpartPage[]
    /** 템플릿 생성을 위한 모달인지 편집을 위한 모달인지 여부 */
    @Prop({ type: String, default: 'new' }) mode!: 'edit' | 'new'

    currentPageId: number = -1

    get hasPageList() {
        const { pages } = this
        return pages && pages.length > 0
    }

    @Watch('pages')
    onPagesLoaded(pages: webpartv3.WebpartPage[]) {
        if (pages && pages.length > 0) {
            this.value.pageId = pages[0].pageId
        }
    }

    created() {
        this.onPagesLoaded(this.pages)
    }
}
